import React, {useMemo, useRef} from 'react'
import {ReactComponent as MdWatch} from '../../assets/icons/MdWatch.svg'

import {ReactComponent as SpatchIcon} from '../../assets/icons/S-Patch.svg'

import {ReactComponent as AppleWatchIcon} from '../../assets/icons/AppleWatchIcon.svg'
import {ReactComponent as CircleIcon} from '../../assets/icons/circle-duotone.svg'
import {ReactComponent as SamsungLogo} from '../../assets/images/Samsung.svg'
import {ReactComponent as WellysisLogo} from '../../assets/images/Wellysis.svg'
import {ReactComponent as AppleLogo} from '../../assets/images/apple-logo-2.svg'
import KioskImage from '../../assets/images/kiosk.png'
import useWindowSize from '../../utils/useWindowSize'
import ExercisesChart from '../exercise/ExercisesChart'
import ExercisesTable from '../exercise/ExercisesTable'
import HealthStat from './HealthStat'

import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Divider} from 'primereact/divider'
import {Message} from 'primereact/message'
import TranslateUtils from '../../i18n/TranslateUtils'
import ECGChart from '../ecg/ECGChart'
import {brands, ECGDeviceTypes} from '../ecg/ECGConstants'
import ECGWrapper from '../ecg/ECGWrapper'
import DeviceActivitiesLog from '../exercise/DeviceActivitiesLog'
import HealthRecordChart from '../health-record-chart/HealthRecordChart'

const Statistic = (props, ref) => {
    useSignals()
    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion

    //#region Import
    const width = useWindowSize()
    //#endregion

    //#region Ref
    const refForm = useRef(null)
    //#endregion

    const initialActiveBrand = useMemo(() => {
        if (!props?.deviceBrand || !props?.deviceAssigned) return brands.samsung

        switch (props?.deviceBrand) {
            case ECGDeviceTypes.samsung:
                return brands.samsung
            case ECGDeviceTypes.apple:
                return brands.apple
            case ECGDeviceTypes.spatch:
                return brands.wellysis
            default:
                return brands.wellysis
        }
    }, [props?.deviceBrand, props?.deviceAssigned])

    //#region State
    const checked = useSignal(true)
    const activeBrand = useSignal(initialActiveBrand)
    //#endregion

    //#region Handle Function
    const handleToggleActivities = () => {
        checked.value = !checked.value
    }
    //#endregion
    //#region Memo
    const brandItemList = useMemo(() => {
        let list = []

        if (!!props?.deviceAssigned) {
            // if (props?.deviceBrand === ECGDeviceTypes.samsung) {
            list.push({
                label: translateCommons('Galaxy Watch'),
                value: brands.samsung,
                logo: SamsungLogo,
                style: {width: '85px', height: '65px'},
                icon: () => <MdWatch style={{width: '26px', height: '36px'}} />,
                onclick: () => (activeBrand.value = brands.samsung),
                deviceName:
                    (props?.deviceBrand === ECGDeviceTypes.samsung &&
                        props?.watchDeviceName) ||
                    '-',
            })
            // }
            // if (props?.deviceBrand === ECGDeviceTypes.apple) {
            list.push({
                label: translateCommons('Apple Watch'),
                value: brands.apple,
                logo: AppleLogo,
                style: {width: '75px', height: '26px'},
                icon: () => (
                    <div style={{height: '40px'}}>
                        <AppleWatchIcon
                            style={{width: '28px', height: '36px'}}
                        />
                    </div>
                ),
                onclick: () => (activeBrand.value = brands.apple),
                deviceName:
                    (props?.deviceBrand === ECGDeviceTypes.apple &&
                        props?.watchDeviceName) ||
                    '-',
            })
            // }
        }

        return [
            ...list,

            {
                label: translateCommons('S-Patch'),
                value: brands.wellysis,
                logo: WellysisLogo,
                style: {width: '70px', height: '30px'},
                icon: () => (
                    <SpatchIcon style={{width: '30px', height: '40px'}} />
                ),
                onclick: () => (activeBrand.value = brands.wellysis),
                deviceName: props?.spatchDeviceName
                    ? `S/Number ${props?.spatchDeviceName}`
                    : '-',
            },
            {
                label: translateCommons('Fixed Kiosk'),
                value: brands.kiosk,
                altText: 'Kiosk',
                style: {width: '75px', height: '65px'},
                icon: () => (
                    <img
                        src={KioskImage}
                        style={{width: '50px', height: '40px'}}
                    />
                ),
                onclick: () => (activeBrand.value = brands.kiosk),
                deviceName: '-',
            },

            // {
            //     label: translateCommons('Smart Insoles'),
            //     value: brands.nurvv,
            //     logo: NurvvLogo,
            //     style: {width: '80px', height: '65px'},
            //     icon: () => (
            //         <IoFootstepsOutline style={{width: '24px', height: '36px'}} />
            //     ),
            //     onclick: () => activeBrand.value =(brands.nurvv),
            // },
            // {
            //     label: translateCommons('Sensor'),
            //     value: brands.prevayl,
            //     logo: PrevaylLogo,
            //     style: {width: '120px', height: '65px'},
            //     icon: () => (
            //         <GiMovementSensor style={{width: '24px', height: '36px'}} />
            //     ),
            //     onclick: () => activeBrand.value =(brands.prevayl),
            // },
        ]
    }, [
        props?.deviceAssigned,
        props?.spatchDeviceName,
        props?.deviceBrand,
        props?.watchDeviceName,
        translateCommons,
        activeBrand,
    ])
    //#endregion

    return (
        <div className="col-12 p-0">
            <Divider type="dashed" />
            <div className="">
                <HealthRecordChart />
            </div>
            <Divider type="dashed" />
            <div className="col-12 p-0">
                <ul className="m-0 p-0">
                    <div className="col-12 mb-3">
                        <div
                            className="flex gap-3 overflow-x-auto"
                            style={{overflowY: 'hidden'}}>
                            {brandItemList?.map((item, index) => (
                                <div
                                    key={index}
                                    className={`${
                                        activeBrand.value === item.value
                                            ? 'border-gray-100 bg-gray-50'
                                            : 'border-white bg-gray-50'
                                    } border-1 pointer p-2`}
                                    onClick={() =>
                                        item?.onclick ? item.onclick() : {}
                                    }
                                    style={{
                                        // backgroundColor:
                                        //     activeBrand.value === item.value
                                        //         ? '#f9f9f9'
                                        //         : 'transparent',
                                        borderRadius: '8px',
                                        width: 300,
                                    }}>
                                    <div className="flex justify-content-between">
                                        {' '}
                                        <div>
                                            {' '}
                                            <div className="flex gap-2 align-items-center">
                                                <CircleIcon
                                                    className={``}
                                                    style={{
                                                        color:
                                                            activeBrand.value ===
                                                            item.value
                                                                ? 'darkcyan'
                                                                : 'lightgray',
                                                    }}
                                                    height={28}
                                                    width={28}
                                                />
                                                <h5 className="font-bold m-0 ">
                                                    {' '}
                                                    {item.label}
                                                </h5>{' '}
                                            </div>{' '}
                                            <p
                                                className="text-center"
                                                style={{fontSize: '12px'}}>
                                                <small className="text-center">
                                                    {!!item?.deviceName &&
                                                    item?.deviceName !== '-'
                                                        ? `${item.deviceName} model`
                                                        : 'N/A'}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="">
                                            {' '}
                                            <div
                                                className="flex justify-content-center align-items-center bg-white h-4rem w-5rem border-round-md mb-2"
                                                style={{
                                                    height: '40px',
                                                    width: '40px',
                                                }}>
                                                {!!item?.icon && item.icon()}
                                            </div>
                                            <div>
                                                {' '}
                                                {item?.logo && (
                                                    <item.logo
                                                        alt={item.label}
                                                        style={item?.style}
                                                    />
                                                )}
                                                {item?.altText && (
                                                    <div className="h-full">
                                                        <h4
                                                            className="font-bold mb-0"
                                                            style={{
                                                                color: 'black',
                                                            }}>
                                                            {item.altText}
                                                        </h4>
                                                    </div>
                                                )}{' '}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </ul>
            </div>
            <div className="border-round-lg">
                {activeBrand.value === brands.samsung && (
                    <React.Fragment>
                        <div className="col-12 p-0">
                            {!checked.value ? (
                                <ExercisesChart
                                    isToggle={!checked.value}
                                    onToggleActivities={handleToggleActivities}
                                    type={ECGDeviceTypes.samsung}
                                />
                            ) : (
                                <div>
                                    <DeviceActivitiesLog />
                                    <ExercisesTable
                                        isToggle={!!checked.value}
                                        onToggleActivities={
                                            handleToggleActivities
                                        }
                                        type={ECGDeviceTypes.samsung}
                                    />{' '}
                                </div>
                            )}
                        </div>
                        <ECGWrapper type={ECGDeviceTypes.samsung} />
                    </React.Fragment>
                )}
                {activeBrand.value === brands.apple && (
                    <React.Fragment>
                        <div className="col-12 p-0">
                            {!checked.value ? (
                                <ExercisesChart
                                    isToggle={!checked.value}
                                    onToggleActivities={handleToggleActivities}
                                    type={ECGDeviceTypes.apple}
                                />
                            ) : (
                                <div>
                                    <ExercisesTable
                                        isToggle={!!checked.value}
                                        onToggleActivities={
                                            handleToggleActivities
                                        }
                                        type={ECGDeviceTypes.apple}
                                    />{' '}
                                </div>
                            )}
                        </div>
                        <ECGWrapper type={ECGDeviceTypes.apple} />
                    </React.Fragment>
                )}
                {activeBrand.value === brands.wellysis && (
                    <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                    width < 992 ? 'overflow-auto' : ''
                                }`}>
                                <ECGWrapper type={ECGDeviceTypes.spatch} />
                            </div>
                        </li>
                    </div>
                )}
                {activeBrand.value === brands.kiosk && (
                    <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                    width < 992 ? 'overflow-auto' : ''
                                }`}>
                                <Message
                                    className="col-12"
                                    severity="info"
                                    text={'No data'}
                                    style={{
                                        height: '50px',
                                    }}
                                />
                            </div>
                        </li>
                    </div>
                )}
                {activeBrand.value === brands.nurvv && (
                    <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                    width < 992 ? 'overflow-auto' : ''
                                }`}>
                                <HealthStat />
                            </div>
                        </li>
                    </div>
                )}
                {activeBrand.value === brands.prevayl && (
                    <div className="col-12 p-0" style={{minHeight: '70vh'}}>
                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center ${
                                    width < 992 ? 'overflow-auto' : ''
                                }`}>
                                {/* <HealthStat /> */}
                            </div>
                        </li>
                        {/* <ECGRecordMonitor /> */}
                        <ECGChart />
                    </div>
                )}{' '}
            </div>
        </div>
    )
}

export default Statistic
